import { render } from "./register-index.vue?vue&type=template&id=28a5c924"
import script from "./register-index.vue?vue&type=script&lang=js"
export * from "./register-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__